module.exports = __webpack_public_path__ + "img/Legendaarinen-Nalle-Mestari.ac98c3cc.png";